import Animations from "../Animations";
export default class NewsLoadMore {
    constructor(block) {
        this.currentPage = 1;
        this.maxPages = 1;
        this.category = null;
        this.block = block;
        this.init();
    }
    init() {
        this.button = this.block.querySelector('[data-load-more]');
        this.loadMoreRow = this.block.querySelector('.load-more-row');
        this.grid = this.block.querySelector('.row.block-fade-up-scroll');
        this.countEl = this.block.querySelector('.load-more-count');
        if (!this.button || !this.grid)
            return;
        const firstPost = this.grid.querySelector('[data-posts]');
        if (firstPost) {
            // data-posts format: "has_more,posts_per_page,max_pages[,category_id]"
            const parts = firstPost.dataset.posts.split(',');
            this.maxPages = parseInt(parts[2]) || 1;
            this.category = parts[3] || null;
        }
        this.button.addEventListener('click', () => this.loadMore());
    }
    loadMore() {
        this.button.disabled = true;
        const formData = new FormData();
        formData.append('action', 'news_load_more');
        formData.append('page', String(this.currentPage));
        if (this.category)
            formData.append('category', this.category);
        fetch(window.localize_script.admin_ajax, { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
            var _a;
            if (data.success && ((_a = data.content) === null || _a === void 0 ? void 0 : _a.length)) {
                data.content.forEach((html) => {
                    const temp = document.createElement('div');
                    temp.innerHTML = html.trim();
                    const el = temp.firstElementChild;
                    this.grid.appendChild(el);
                    Animations.animateNewsCard(el);
                });
                this.currentPage = data.page;
                this.updateCount(data.content.length);
                if (this.currentPage >= this.maxPages) {
                    this.loadMoreRow.classList.add('hidden');
                }
            }
            else {
                this.loadMoreRow.classList.add('hidden');
            }
            this.button.disabled = false;
        });
    }
    updateCount(loaded) {
        if (!this.countEl)
            return;
        const visible = parseInt(this.countEl.dataset.visible || '0') + loaded;
        const total = parseInt(this.countEl.dataset.total || '0');
        const template = this.countEl.dataset.template || '{visible} from {total} news';
        this.countEl.dataset.visible = String(visible);
        this.countEl.textContent = template
            .replace('{visible}', String(visible))
            .replace('{total}', String(total));
    }
}
